<script>
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex'
import DocumentGrid from '../Document/DocumentGrid'
import DocumentUpload from '../Document/DocumentUpload'

export default {
  name: 'CourseDocuments',
  props: ['count'],
  components: {
    DocumentGrid,
    DocumentUpload
  },
  data () {
    return {
      hideEntity: true
    }
  },
  computed: {
    ...mapState('classes', {
      classId: state => state.sessionInformation.classId,
      mode: s => s.sessionInformation.mode,
      sessionInformation: s => s.sessionInformation
    }),
    ...mapState('documents', {
      documentUploadState: s => s.uploadModal.open
    }),
    canDelete(){
      let activeApproval = this.sessionInformation.approvals && this.sessionInformation.approvals[0]
      let canDelete = (activeApproval && activeApproval.LK_CLASS_APPROVAL_STATUS_ID != 3 /**Rejected */) ? false : true
      canDelete = (this.$p(['ADMIN'])) ? true : canDelete
      return canDelete
    }
  },
  methods: {
  }
}
</script>

<template>
  <div class="fit">
    <DocumentGrid :entityItemId="classId" :deletable="canDelete"/>
    <document-upload v-if="documentUploadState" :hideEntity="hideEntity" :entityItemId="classId"/>
  </div>
</template>

<style>
</style>
